@if (canSwitchTenants()) {
  <button
    mat-button
    [matMenuTriggerFor]="tenantMenu"
    class="min-w-0 px-2 h-9 text-sm"
    aria-label="Switch tenant"
  >
    <div class="flex items-center gap-1">
      <mat-icon style="scale: 0.8">apartment</mat-icon>
      <span class="font-medium text-xs">{{ currentTenantDisplayName() }}</span>
      <mat-icon style="scale: 0.5">expand_more</mat-icon>
    </div>
  </button>

  <mat-menu #tenantMenu="matMenu">
    @if (currentTenant()) {
      <div class="bg-gray-50 cursor-default p-3" mat-menu-item disabled>
        <div class="space-y-1">
          <div class="text-sm font-medium">{{ currentTenant()?.name }}</div>
          <div class="text-xs text-gray-500">{{ currentTenantCode() }}</div>
        </div>
      </div>
      <mat-divider></mat-divider>
    }

    <button mat-menu-item [matMenuTriggerFor]="switchTenantMenu" class="text-sm">
      <mat-icon class="text-sm mr-3">swap_horiz</mat-icon>
      <span>Switch tenant</span>
    </button>

    @if (isSuperUser()) {
      <button mat-menu-item (click)="goToTenantSettings()" class="text-sm">
        <mat-icon class="text-sm mr-3">settings</mat-icon>
        <span>Settings</span>
      </button>
    }
  </mat-menu>

  <mat-menu #switchTenantMenu="matMenu">
    @for (tenant of availableTenants(); track tenant.id) {
      <button
        mat-menu-item
        (click)="switchToTenant(tenant)"
        [class.font-semibold]="tenant.shortCode === currentTenantCode()"
        class="text-sm p-3"
      >
        <div class="flex items-center justify-between w-full">
          <div class="space-y-1">
            <div class="text-sm">{{ tenant.name || 'loading...' }}</div>
            @if (tenant.shortCode) {
              <div class="text-xs text-gray-500">{{ tenant.shortCode }}</div>
            }
          </div>
          @if (tenant.shortCode === currentTenantCode()) {
            <mat-icon class="text-sm text-primary ml-2">check</mat-icon>
          }
        </div>
      </button>
    }
  </mat-menu>
}
